/* Cut to length: hide "Shorten to" options that are not shorter than the
   selected variant, and reset the select when its choice becomes invalid.
   Link counts come from the variant title (leading digits, e.g. "104 links")
   and from each option's data-links. Follows Dawn's variantChange event. */
(function () {
  var LEADING_NUMBER = /^\s*(\d+)/;
  function links(text) {
    var m = LEADING_NUMBER.exec(text || '');
    return m ? parseInt(m[1], 10) : NaN;
  }

  function apply(root, variantTitle) {
    var select = root.querySelector('[data-cut-to-length-select]');
    if (!select) return;
    var current = links(variantTitle);
    Array.prototype.forEach.call(select.options, function (opt) {
      if (!opt.value) return; // "No — full length" is always valid
      var invalid = !isNaN(current) && links(opt.dataset.links || opt.value) >= current;
      opt.disabled = invalid;
      opt.hidden = invalid;
    });
    if (select.selectedOptions[0] && select.selectedOptions[0].disabled) select.value = '';
    // Only submit the property when a length is chosen (no blank "Shorten to" on the order).
    select.name = select.value ? select.dataset.propertyName : '';
  }

  function init() {
    var roots = document.querySelectorAll('[data-cut-to-length]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      apply(root, root.dataset.variantTitle);
      root.addEventListener('change', function () { apply(root, root.dataset.variantTitle); });
    });
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var variant = e && e.data && e.data.variant;
      if (!variant || !variant.title) return;
      roots.forEach(function (root) {
        root.dataset.variantTitle = variant.title;
        apply(root, variant.title);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
